import SinginPageImage from "..";
import ResetPassword from "./reset-password";

const ForgetPassword = () => {
  return (
    <div className="container full-height valign-wrapper row-relative">
      <div className="row">
        <SinginPageImage />
        <ResetPassword />
      </div>
    </div>
  );
};

export default ForgetPassword;
